/**
 * Converts a camelCase string to a phrase, by inserting spaces between words.
 *
 * The function works by inserting a space before each uppercase letter that is not
 * the first letter of the string, and then capitalizing the first letter of
 * the resulting phrase.
 *
 * @example
 * camelToPhrase('helloWorld') // 'Hello World'
 */
export const camelToPhrase = (word: string) =>
  word
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/^./, s => s.toUpperCase());
